import Head from 'next/head'
import GoogleReviewScreen from '../screens/GoogleReviewScreen'

export default function Review() {
  return (
    <>
      <Head>
        <title>CollegePass Reviews | Customer Success Stories</title>
        <meta
          name="description"
          content="Read CollegePass reviews from families and students admitted to top US, UK, and Canadian universities."
        />
        <meta itemprop="name" content="CollegePass Reviews | Customer Success Stories" />
        <meta
          itemprop="description"
          content="Read CollegePass reviews from families and students admitted to top US, UK, and Canadian universities."
        />
        <meta itemprop="image" content="" />
        <meta property="og:url" content="https://www.collegepass.org/terms" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="CollegePass Reviews | Customer Success Stories" />
        <meta
          property="og:description"
          content="Read CollegePass reviews from families and students admitted to top US, UK, and Canadian universities."
        />
        <meta property="og:image" content="https://collegepass-logos.s3.ap-south-1.amazonaws.com/G_REVIEWS.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CollegePass Reviews | Customer Success Stories" />
        <meta
          name="twitter:description"
          content="Read CollegePass reviews from families and students admitted to top US, UK, and Canadian universities."
        />
        <meta name="twitter:image" content="https://collegepass-logos.s3.ap-south-1.amazonaws.com/G_REVIEWS.jpg" />
        <link rel="canonical" href="https://www.collegepass.org/customer-reviews" />
      </Head>

      <main className="bg-black">
        <GoogleReviewScreen></GoogleReviewScreen>
      </main>
    </>
  )
}
